import { endpoints, getIDFromUrl } from '@rossum/api-client';
import { SchemaSection } from '@rossum/api-client/schemas';
import { useQueries } from '@tanstack/react-query';
import { api } from '../../../../lib/apiClient';
import { FORMULA_PREVIEW_KEY } from '../../keys';
import {
  ContentForPreview,
  makeArtificialContent,
} from './makeArtificialContent';

type UseCalculatePreview = {
  content: ContentForPreview[];
  schemaContent: SchemaSection[];
  disabled?: boolean;
  queueName?: string;
  workspaceName?: string;
};

export const useCalculatePreview = ({
  content,
  schemaContent,
  disabled,
  queueName,
  workspaceName,
}: UseCalculatePreview) => {
  const queries = content.map(item => {
    const queryKey = [
      FORMULA_PREVIEW_KEY,
      'annotation-content',
      item,
      schemaContent,
    ] as const;

    return {
      queryKey,
      queryFn: async () => {
        const annotationContent =
          item.type === 'from_annotation'
            ? await api
                .request(
                  endpoints.annotations.getContent(
                    getIDFromUrl(item.annotationUrl)
                  )
                )
                .then(({ results }) => results)
            : makeArtificialContent(item.dependencies, schemaContent);

        return api
          .request(
            endpoints.internal.schemas.evaluateFormulas({
              annotationContent,
              schemaContent,
              queueName,
              workspaceName,
            })
          )
          .then(response => ({
            // adding the annotation id to the response for easier matching
            ...response,
            content: item,
          }));
      },
      enabled: schemaContent.length > 0 && !disabled,
    };
  });

  return useQueries({ queries });
};
